import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { GET_QUERY_INITIALIZE, GET_QUERY_LIST_RESULT, GET_QUERY_DATA_ATTEMPT, GET_MULTIPLE_QUERY_DATA_ATTEMPT,
     GET_MAP_SPECIAL_ATTEMPT, GET_MAP_WITH_KEY_SPECIAL_ATTEMPT, INITIALIZE_DATA, GET_QUERY_DATA_DATA_POOL_ATTEMPT, GET_MULTIPLE_QUERY_DATA_DATA_POOL_ATTEMPT} from '../Actions/LogisticActions'
import { GET_REQUEST_DATA_POOL_PARAMETER_API, GET_REQUEST_PARAMETER_API } from '../Services/API'
import { UNAUTHORIZED_HTTP_CODE, UNAUTHORIZED_CASE } from '../Actions/AuthorizationActions'
import {LS_MAP} from '../Components/PlayGeneralMap'
import {LS_WITH_KEY_MAP} from '../Components/PlayGeneralMapWithKey'
import { makeid } from '../Services/Utilities'

function* GeneralGet_Saga(action) {
    const  Result = yield call(GET_REQUEST_PARAMETER_API, action.Container.Path, action.Container.Value)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code == 200){
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.DataParameter]: Result.data.data,
                [action.Container.GetErrorParameter]: ''
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.GetErrorParameter]: Result.message
            }
        })
    }
    
}

function* GeneralGetDataPool_Saga(action) {
    const  Result = yield call(GET_REQUEST_DATA_POOL_PARAMETER_API, action.Container.Path, action.Container.Value)
    

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code == 200){
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.DataParameter]: Result.data.data,
                [action.Container.GetErrorParameter]: ''
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.GetErrorParameter]: Result.message
            }
        })
    }
    
}

function* GeneralInitialize_Saga(action) {
    yield put({
        type:GET_QUERY_LIST_RESULT,
        Container:{
            [action.Container.DataParameter]: action.Container.Data,
        }
    })
}


function* GetMapSpecial_Saga(action) {
    

    let student_key = localStorage.getItem('student_key_ABCDEFG') 
    student_key = student_key || (makeid(5)+  Date.now())
    localStorage.setItem('student_key_ABCDEFG', student_key) 


    const  Result = yield call(GET_REQUEST_PARAMETER_API, action.Container.Path, action.Container.Value)
    
    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code == 200){
        let Data = Result.data.data

        let MapKey = LS_MAP + Data.Id
        console.log(MapKey)
        let CurrentMapData = localStorage.getItem(MapKey)
        console.log(Object.entries(localStorage))
        console.log(CurrentMapData)
        console.log((CurrentMapData == 'undefined' || !CurrentMapData))

        if(CurrentMapData == 'undefined' || !CurrentMapData){
            
            Data = ({
                ...Data,
                student_key:student_key,
                LS: {
                    DataExists: false
                }
            })


        }
        else{
           
            let LS_MAP = JSON.parse(CurrentMapData)

            //Check Changes
            let Answers = LS_MAP.Answers

            let SaveAnswers = []
            console.log(Answers.filter((a) => Data.Elements.map((e) => e.Id).includes(a.ElementId)))
            for(let A of Answers.filter((a) => Data.Elements.map((e) => e.Id).includes(a.ElementId))){
                let MapA = Data.Elements.filter((e) => e.Id == A.ElementId)[0]
                console.log(A)
                console.log(MapA)

                if( MapA.QuestionSeriesId && A.Id == MapA.QuestionSeriesId){
                    SaveAnswers.push(A)
                }
            }

            let UPDATE_LS_MAP = ({
                ...LS_MAP,
                Answers: SaveAnswers
            })

            localStorage.setItem(MapKey, JSON.stringify(UPDATE_LS_MAP))

            let Elements = Data.Elements.map((e) => ({
                ...e,
                LS_Answer: UPDATE_LS_MAP.Answers.filter((a) => a.ElementId == e.Id).length ? 
                UPDATE_LS_MAP.Answers.filter((a) => a.ElementId == e.Id)[0] : undefined
            }))

            Data = ({
                ...Data,
                Elements: Elements,
                student_key:student_key,
                LS: {
                    DataExists: true,
                    LS_MAP: UPDATE_LS_MAP
                }
            })
        }

        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.DataParameter]: Data,
                [action.Container.GetErrorParameter]: ''
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.GetErrorParameter]: Result.message
            }
        })
    }
    
}

function* GetMapWithKeySpecial_Saga(action) {
    console.log('GetMapSpecial_Saga')
    console.log(action.Container.Path)

    const  Result = yield call(GET_REQUEST_PARAMETER_API, action.Container.Path, action.Container.Value)
    
    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code == 200){
        let Data = Result.data.data

        let MapKey = LS_WITH_KEY_MAP + Data.Id
        console.log(MapKey)
        let CurrentMapData = localStorage.getItem(MapKey)
        console.log(Object.entries(localStorage))
        console.log(CurrentMapData)
        console.log((CurrentMapData == 'undefined' || !CurrentMapData))

        if(CurrentMapData == 'undefined' || !CurrentMapData){
            
            Data = ({
                ...Data,
                LS: {
                    DataExists: false
                }
            })


        }
        else{
           
            let LS_MAP = JSON.parse(CurrentMapData)

            //Check Changes
            let Answers = LS_MAP.Answers

            let SaveAnswers = []
            console.log(Answers.filter((a) => Data.Elements.map((e) => e.Id).includes(a.ElementId)))
            for(let A of Answers.filter((a) => Data.Elements.map((e) => e.Id).includes(a.ElementId))){
                let MapA = Data.Elements.filter((e) => e.Id == A.ElementId)[0]
                console.log(A)
                console.log(MapA)

                if( MapA.QuestionSeriesId && A.Id == MapA.QuestionSeriesId){
                    SaveAnswers.push(A)
                }
            }

            let UPDATE_LS_MAP = ({
                ...LS_MAP,
                Answers: SaveAnswers
            })

            localStorage.setItem(MapKey, JSON.stringify(UPDATE_LS_MAP))

            let Elements = Data.Elements.map((e) => ({
                ...e,
                LS_Answer: UPDATE_LS_MAP.Answers.filter((a) => a.ElementId == e.Id).length ? 
                UPDATE_LS_MAP.Answers.filter((a) => a.ElementId == e.Id)[0] : undefined
            }))

            Data = ({
                ...Data,
                Elements: Elements,
                LS: {
                    DataExists: true,
                    LS_MAP: UPDATE_LS_MAP
                }
            })
        }

        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.DataParameter]: Data,
                [action.Container.GetErrorParameter]: ''
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.GetErrorParameter]: Result.message
            }
        })
    }
    
}

function* GeneralMultiGet_Saga(action) {
for (const Container of action.Containers) {
      
    const  Result = yield call(GET_REQUEST_PARAMETER_API, Container.Path, Container.Value)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }
    
    if(Result.Code == 200){
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [Container.SearchParameter]: false,
                [Container.DataParameter]: Result.data.data,
                [Container.GetErrorParameter]: ''
            }
        })

       
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [Container.SearchParameter]: false,
                [Container.GetErrorParameter]: Result.message
            }
        })
    }
}
    
    
}

function* GeneralMultiDataPoolGet_Saga(action) {
    for (const Container of action.Containers) {
          
        const  Result = yield call(GET_REQUEST_DATA_POOL_PARAMETER_API, Container.Path, Container.Value)
    
        if(Result.Code == UNAUTHORIZED_HTTP_CODE){
            yield put({
                type:UNAUTHORIZED_CASE
            })
    
            return
        }
        
        if(Result.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [Container.SearchParameter]: false,
                    [Container.DataParameter]: Result.data.data,
                    [Container.GetErrorParameter]: ''
                }
            })
    
            
        }
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [Container.SearchParameter]: false,
                    [Container.GetErrorParameter]: Result.message
                }
            })
        }
    }
        
        
    }

export default function* GeneralGetSaga(){
    yield takeLatest(GET_QUERY_DATA_ATTEMPT, GeneralGet_Saga)
    yield takeLatest(GET_QUERY_DATA_DATA_POOL_ATTEMPT, GeneralGetDataPool_Saga)
    yield takeLatest(INITIALIZE_DATA, GeneralInitialize_Saga)

    yield takeLatest(GET_MULTIPLE_QUERY_DATA_ATTEMPT, GeneralMultiGet_Saga)
    yield takeLatest(GET_MULTIPLE_QUERY_DATA_DATA_POOL_ATTEMPT, GeneralMultiDataPoolGet_Saga)
    yield takeLatest(GET_MAP_SPECIAL_ATTEMPT, GetMapSpecial_Saga)
    yield takeLatest(GET_MAP_WITH_KEY_SPECIAL_ATTEMPT, GetMapWithKeySpecial_Saga)


}